/**
 * Vertical ordering of Journeys Sankey nodes within a column.
 *
 * Every node with no outgoing link lands in the right-hand column — outcomes and
 * every leaf tool, retriever and embedding call. nivo's default orders a column
 * by link geometry, which interleaves those families. Ranking by category keeps
 * each one in a contiguous block. d3-sankey applies the comparator per column,
 * so hops in the middle columns group the same way.
 */

export const NODE_CATEGORY_ORDER = [
  // Spine kinds first, in the order a step can be typed: an agent, a step the
  // framework did not type as one, or a bare model call.
  'WORKFLOW', 'AGENT', 'CHAIN', 'LLM', 'MODEL', 'OPERATION', 'OUTCOME',
  'TOOL', 'RETRIEVER', 'EMBEDDING', 'RERANKER',
];

const NODE_CATEGORY_RANK = new Map(NODE_CATEGORY_ORDER.map((type, i) => [type, i]));

/**
 * Passed to nivo as `sort`. A function rather than 'input' because 'input' also
 * disables d3's link ordering, which is what keeps ribbons from crossing at a
 * node. An unranked type sorts last rather than being dropped or reordered.
 */
export function compareNodesByCategory(a, b) {
  const rankA = NODE_CATEGORY_RANK.get(a.nodeType || a.type) ?? NODE_CATEGORY_ORDER.length;
  const rankB = NODE_CATEGORY_RANK.get(b.nodeType || b.type) ?? NODE_CATEGORY_ORDER.length;
  if (rankA !== rankB) return rankA - rankB;

  // Busiest first inside a family, then id so the order never depends on which
  // traces happened to arrive first.
  const tracesA = a.trace_count ?? 0;
  const tracesB = b.trace_count ?? 0;
  if (tracesA !== tracesB) return tracesB - tracesA;
  return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
}
